import { render, staticRenderFns } from "./FileApprovalFileListItem.vue?vue&type=template&id=0ef105da"
import script from "./FileApprovalFileListItem.vue?vue&type=script&lang=js"
export * from "./FileApprovalFileListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports